import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IAppointment } from '@shared/services/appointment.service';

@Component({
	selector: 'app-generic-calendar-component',
	templateUrl: './generic-calendar.component.html',
	styleUrls: ['./generic-calendar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class GenericCalendarComponent implements OnInit, AfterViewInit {
	@Input() month = 0;
	@Input() year = 0;
	@Input() appointments = null;
	@Input() addAppointmentIcon = false;

	@Output() appointmentClickedEvent: EventEmitter<any> = new EventEmitter();
	@Output() appointmentDeleteClickedEvent: EventEmitter<any> = new EventEmitter();

	@Output() calendarDayClickedEvent: EventEmitter<any> = new EventEmitter();

	constructor(public dialog: MatDialog) {}

	monthName = '';
	yearDisplay = this.year;
	weeks = [];
	firstMonday = new Date();
	initDone = false;

	ngOnInit(): void {}
	ngAfterViewInit(): void {}

	ngOnChanges(changes: SimpleChanges) {
		for (const propName in changes) {
			if (propName in changes) {
				switch (propName) {
					case 'appointments': {
						this.updateCalendar();
					}
				}
			}
		}
	}

	updateCalendar() {
		const firstDayOfMonth = this.getFirstDayOfMonth(this.year, this.month);
		this.firstMonday = this.getMonday(firstDayOfMonth);
		let isMonday = true;
		const iDay = this.firstMonday;
		let week;
		let sameMonth;
		let parsedApps;
		let thisDaysApps = [];
		this.weeks.length = 0;
		if (this.appointments) {
			parsedApps = this.appointments.map((appointment) => {
				return {
					...appointment,
					startTime: new Date(appointment.startTime.slice(0, 10)),
					endTime: new Date(appointment.endTime.slice(0, 10)),
				};
			});
		}

		do {
			if (isMonday) {
				week = {
					nr: this.getWeek(iDay),
					days: [],
				};
			}
			const dayInMonth = iDay.getMonth() === this.month;
			if (parsedApps) {
				thisDaysApps = parsedApps.filter((app) => iDay.setHours(0, 0, 0, 0) >= app.startTime.setHours(0, 0, 0, 0) && iDay.setHours(0, 0, 0, 0) <= app.endTime.setHours(0, 0, 0, 0));
			}

			week.days.push({
				day: iDay.getDate(),
				in_month: dayInMonth,
				appointments: thisDaysApps,
			});

			if (this.getDayOfWeek(iDay) === 'Sunday') {
				this.weeks.push(week);
			}

			iDay.setDate(iDay.getDate() + 1);
			isMonday = this.getDayOfWeek(iDay) === 'Monday';

			sameMonth = iDay.getMonth() === this.month;
		} while (sameMonth || !isMonday);

		const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

		this.monthName = monthNames[this.month];
	}

	getMonday(_) {
		const date = new Date(_);
		const day = date.getDay();
		const diff = date.getDate() - day + (day === 0 ? -6 : 1);
		return new Date(date.setDate(diff));
	}

	getFirstDayOfMonth(year, month): Date {
		return new Date(year, month, 1);
	}

	getDayOfWeek(date) {
		const dayOfWeek = new Date(date).getDay();
		return Number.isNaN(dayOfWeek) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
	}

	onAppointmentClick(appointment: IAppointment) {
		this.appointmentClickedEvent.emit(appointment);
	}

	onDayClick(object: any) {
		if (object.appointments.length) return;

		let clickedDate: Date;

		if (!object.in_month) {
			// If the day belongs to the previous month
			if (object.day > 15) {
				clickedDate = new Date(this.year, this.month - 1, object.day);

				// Handle January to December transition
				if (this.month === 0) {
					clickedDate = new Date(this.year - 1, 11, object.day);
				}
			}
			// If the day belongs to the next month
			else {
				clickedDate = new Date(this.year, this.month + 1, object.day);

				// Handle December to January transition
				if (this.month === 11) {
					clickedDate = new Date(this.year + 1, 0, object.day);
				}
			}
		} else {
			// The day is within the current month
			clickedDate = new Date(this.year, this.month, object.day);
		}

		this.calendarDayClickedEvent.emit(clickedDate);
	}

	deleteAppointment(event, appointment: IAppointment) {
		event.stopPropagation();
		this.appointmentDeleteClickedEvent.emit(appointment);
	}

	getWeek(inputDate: Date) {
		const date = new Date(inputDate.getTime());
		const week1 = new Date(date.getFullYear(), 0, 4);
		date.setHours(0, 0, 0, 0);
		// Thursday in current week decides the year.
		date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
		// January 4 is always in week 1.
		// Adjust to Thursday in week 1 and count number of weeks from date to week1.
		return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
	}
}
